var _clipPath, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcademyHeaderIcon = function SvgAcademyHeaderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.69 41.21"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "academyHeaderIcon_svg__logo-site-academy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3v20.61l17.84 10.3 17.85-10.3V10.3L17.84 0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#61ad00",
    d: "M0 10.3v20.61l17.84 10.3 17.85-10.3V10.3L17.84 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#academyHeaderIcon_svg__logo-site-academy)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0e7b2",
    d: "M25.49 36.83 8.03 34.74V8.55l17.46-2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m25.49 36.83 3.81-2.2V14.42l-3.81-7.96zM12.95 14.81l-3.01.17v-4.44l3.01-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m17.76 14.52-3.25.19v-4.62l3.25-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m23.01 14.2-3.55.22V9.6l3.55-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m12.95 20.89-3.01.02v-4.44l3.01-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m17.76 20.86-3.25.02v-4.63l3.25-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m23.01 20.82-3.55.02v-4.82l3.55-.16zm-10.06 6.15-3.01-.14v-4.44l3.01.02zm4.81.22-3.25-.15v-4.62l3.25.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m23.01 27.44-3.55-.17v-4.82l3.55.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m12.95 33.05-3.01-.3v-4.44l3.01.18zm10.06 1-3.55-.35v-4.82l3.55.21zM12.95 10.24l-3.01.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m9.94 14.98 3.01-.17v-.38l-3.01-3.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m17.76 9.76-3.25.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "M17.76 14.52V9.76l-3.25.33v4.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547e30",
    d: "m19.46 9.6 3.55-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "m9.94 20.91 3.01-.02v-4.56l-3.01.14zm4.57-.03 3.25-.02v-.2l-3.25-4.21zm-4.57 5.95 3.01.14v-4.56l-3.01-.02zm4.57.21 3.25.15v-4.75l-3.25-.02zm4.95.23 3.55.17-3.55-4.59zm-9.52 5.48 3.01.3v-4.56l-3.01-.18zm9.52.95 3.55.35v-4.96l-3.55-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588328",
    d: "M12.53 16.76v3.72h-2.18v-3.62zm.41-.43-3 .14v4.44h3zm10.07 4.49-3.55.02v-4.82l3.55-.16zM10.35 22.8h2.18v3.72l-2.18-.1zm-.41-.41v4.44l3 .14v-4.56h-3zm4.98.44h2.44v3.92l-2.44-.11zm-.41-.41V27l3.26.15v-4.71h-3.26zm3.25 13.49-3.25-.39v-6.94l3.25.2z"
  }))));
};
export default SvgAcademyHeaderIcon;